import { Modal, Dropdown, Collapse, Tab, Tooltip, Alert } from "bootstrap";

// Bootstrap 5 の ESM は data-API(data-bs-toggle / data-bs-dismiss のクリック
// 委譲)をモジュール top-level の `EventHandler.on(document, ...)` で登録するが、
// webpack production の tree-shaking 下ではこの副作用が保持されず、`import * as
// bootstrap` で window.bootstrap を張っても data-API が発火しない(トグルを
// クリックしてもドロップダウン/モーダルが開かない)。従来はこの穴を legacy
// バンドルの jQuery + Bootstrap jQuery プラグインが埋めていたが、jQuery 撤去
// (#2428) でそれが失われ、全ページのドロップダウン/モーダル/collapse が沈黙した。
//
// tree-shaking に依存せず data-API を確定的に配線する。対応するのはアプリで
// 実際に使う data-bs-toggle(modal/dropdown/collapse/tab/tooltip)と
// data-bs-dismiss(modal/alert)のみ。各コンポーネントの getOrCreateInstance を
// 呼ぶだけで BS5 が表示/トグルの状態管理を行う。

const TOGGLE_HANDLERS = {
  modal: (target) => Modal.getOrCreateInstance(target).toggle(),
  dropdown: (target) => Dropdown.getOrCreateInstance(target).toggle(),
  collapse: (target) => Collapse.getOrCreateInstance(target).toggle(),
  tab: (target) => Tab.getOrCreateInstance(target).show(),
};

// dropdown / tab のトグル要素は自身がインスタンス対象(target 属性ではなく要素本体)。
const SELF_TARGET = new Set(["dropdown", "tab"]);

const resolveTarget = (trigger, type) => {
  if (SELF_TARGET.has(type)) return trigger;
  const selector =
    trigger.getAttribute("data-bs-target") ||
    (trigger.getAttribute("href") || "").trim();
  return selector && selector !== "#" ? document.querySelector(selector) : null;
};

document.addEventListener("click", (event) => {
  const toggle = event.target.closest?.("[data-bs-toggle]");
  if (toggle) {
    const type = toggle.getAttribute("data-bs-toggle");
    const handler = TOGGLE_HANDLERS[type];
    if (handler) {
      const target = resolveTarget(toggle, type);
      if (target) {
        if (toggle.tagName === "A") event.preventDefault();
        handler(target);
      }
      return;
    }
  }

  const dismiss = event.target.closest?.("[data-bs-dismiss]");
  if (dismiss) {
    const type = dismiss.getAttribute("data-bs-dismiss");
    if (type === "modal") {
      const modal = dismiss.closest(".modal");
      if (modal) Modal.getOrCreateInstance(modal).hide();
    } else if (type === "alert") {
      const alert = dismiss.closest(".alert");
      if (alert) Alert.getOrCreateInstance(alert).close();
    }
  }
});

// tooltip は data-API のクリック委譲ではなく、対象要素ごとの初期化が必要。
const initTooltips = () => {
  document
    .querySelectorAll('[data-bs-toggle="tooltip"]')
    .forEach((el) => Tooltip.getOrCreateInstance(el));
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initTooltips);
} else {
  initTooltips();
}
document.addEventListener("turbo:load", initTooltips);
